import React, { Component } from "react";
import AppModalBs from "../../partials/AppModalBs";
import AppInput from "../../partials/AppInput";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export class CategoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      school_id: "",
      logo: "",
      name: "",
      description: "",
      schoolOptions: [],
    };
  }

  componentDidMount() {
    window.CategoryModal = this;
    if (this.props.api && this.props.api.apiGetAllSchoolListSuperAdmin) {
      this.props.api.apiGetAllSchoolListSuperAdmin().then((res) => {
        let options = res.data?.options ? res.data.options("school_id", "school_name") : [];
        this.setState({ schoolOptions: options });
      }).catch(console.error);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.modalKey !== prevProps.modalKey) {
      this.setState({
        school_id: "",
        logo: "",
        name: "",
        description: "",
      });
    }
  }



  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(e, this.state);
    }
  };

  render() {
    let { id, title, onClose, submitText = "Save" } = this.props;
    const { school_id, logo, name, description, schoolOptions } = this.state;

    return (
      <AppModalBs id={id} title={title} onClose={onClose} size="modal-lg">
        <form onSubmit={this.handleSubmit} key={this.props.modalKey || 'add-modal'}>
          <div className="p-4">
            <div className="row mb-3">
              <div className="col-md-6">
                <AppInput
                  type="text"
                  name="name"
                  label="Category Name"
                  placeholder="enter"
                  defaultValue={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  required={true}
                />
              </div>
              <div className="col-md-6">
                <div className="form-group mb-0">
                  <label className="col-form-label">
                    Logo <span className="text-danger">*</span>
                  </label>
                  <div style={{ display: "block", marginTop: "2px" }}>
                    <Upload
                      beforeUpload={(file) => {
                        this.setState({ logo: file });
                        return false;
                      }}
                      onRemove={() => this.setState({ logo: "" })}
                      maxCount={1}
                      fileList={logo ? [
                        {
                          uid: "1",
                          name: logo instanceof File ? logo.name : "File",
                          status: "done",
                        }
                      ] : []}
                    >
                      <Button icon={<UploadOutlined />} className="w-100" style={{ textAlign: "left" }}>
                        Upload Logo
                      </Button>
                    </Upload>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-12">
                <AppInput
                  type="textarea"
                  name="description"
                  label="Description"
                  placeholder="Enter description"
                  defaultValue={description}
                  onChange={(e) => this.setState({ description: e.target.value })}
                  required={true}
                  attrs={{ rows: 2 }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end p-3 px-4">
            <button
              type="button"
              className="btn btn-light border px-4 fw-bold text-secondary me-3"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-warning text-white px-4 fw-bold"
              style={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}
            >
              {submitText}
            </button>
          </div>
        </form>
      </AppModalBs>
    );
  }
}

export default CategoryModal;
